// A player's nickname always goes with its flag (owner 2026-11-01: "nazwy nicków zawsze stylizuj z ich flagami"), in the
// lobby's look, also where the name sits inside a sentence. No country known (a guest): no flag (owner 2026-11-02: the
// "?" stand-in said nothing, a guest always had it).
import { Fragment, type ReactNode } from 'react';
import type { SeatNames } from '../hearts/names';
import { withSuits } from '../hearts/suits';
import { flagUrl } from '../multiplayer/store';
import { sharpFlag } from '../options/assets';

export function PlayerFlag({ flag }: { flag?: string | undefined }) {
  if (!flag) return null;
  return <img className="mp_flag" src={sharpFlag(flagUrl(flag))} alt="" width={16} height={11} />;
}

/** A translated sentence with the flag put right before the name, wherever the language has it. */
export function WithFlag({ text, name, flag }: { text: string; name: string; flag?: string | undefined }) {
  const at = name ? text.indexOf(name) : -1;
  if (at < 0) return <>{text}</>;
  return (
    <>
      {text.slice(0, at)}
      <PlayerFlag flag={flag} />
      {name}
      {text.slice(at + name.length)}
    </>
  );
}

/** A card table's sentence ("Choose 3 cards and pass them left (Anna)"), suits as icons, each real player's name with its
 *  flag. Offline, and for a bot, no flags: only the suits. */
export function flagged(text: string, names: SeatNames | null | undefined): ReactNode[] {
  const flagOf = new Map<string, string>();
  names?.flags?.forEach((flag, seat) => {
    const name = names.name[seat];
    if (flag && name && !names.benched?.[seat]) flagOf.set(name, flag); // a guest ('') has no flag (owner 2026-11-02)
  });
  if (!flagOf.size) return withSuits(text);
  const pattern = [...flagOf.keys()].sort((a, b) => b.length - a.length).map((n) => n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
  return text.split(new RegExp(`(${pattern})`)).map((part, i) => (
    <Fragment key={i}>
      {flagOf.has(part) ? (
        <>
          <PlayerFlag flag={flagOf.get(part)} />
          {part}
        </>
      ) : (
        withSuits(part)
      )}
    </Fragment>
  ));
}
